import axios from "axios";
import { useAuthStore } from "@/store/authStore";

// In production, use relative URLs (same origin). In development, use localhost or VITE_API_URL
const API_BASE_URL = import.meta.env.VITE_API_URL || 
  (import.meta.env.PROD ? "" : "http://localhost:3000");

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    // Only log in development mode
    if (import.meta.env.DEV && import.meta.env.VITE_LOG_API === "true") {
      console.log(
        "API Request:",
        config.method?.toUpperCase(),
        config.url,
        config.data
      );
    }
    const { token } = useAuthStore.getState();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error("API Request Error:", error);
    return Promise.reject(error);
  }
);

// Response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => {
    // Only log in development mode
    if (import.meta.env.DEV && import.meta.env.VITE_LOG_API === "true") {
      console.log(
        "API Response:",
        response.status,
        response.config.url,
        response.data
      );
    }
    return response;
  },
  (error) => {
    console.error(
      "API Response Error:",
      error.response?.status,
      error.config?.url,
      error.response?.data
    );
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Token is invalid or expired, logout user
      const { logout } = useAuthStore.getState();
      logout();
      // Redirect to login page
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
